import React from 'react';
import { KpeActiveYear } from '../../../_shared/types';
import { Button } from '../../../_shared/components/Button/Button';
import { Typography } from '../../../_shared/components/Typography/Typography';
import { Card } from '../../../_shared/components/Card/Card';
import styles from './KpeActiveYearCard.module.scss';

interface Props {
  data: KpeActiveYear;
  onPlan: () => void;
}

export function KpeActiveYearCard({ data, onPlan }: Props) {
  return (
    <Card className={styles.card}>
      <div className={styles.left}>
        <Typography variant="h2">{data.year}</Typography>
        <Typography variant="text">
          Спланируйте свои показатели на&nbsp;будущий 2027 год <br />
          и&nbsp;добейтесь лучших результатов!
        </Typography>
        <Button className={styles.button} onClick={onPlan}>
          Спланировать показатели
        </Button>
      </div>
      <div className={styles.right}>
        <div className={styles.deadlines}>
          {data.deadlines.map((d, i) => (
            <div key={i} className={styles.deadlineRow}>
              <Typography variant={'h6'} className={styles.deadlineDate}>
                {d.date}
              </Typography>
              <Typography variant={'text'}>{d.label}</Typography>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
}
